<template>
    <div class="container-fluid">

        <!-- Eget google-drive tipinde token yoksa goster -->
        <a v-bind:href="googleDriveAuthLink" target="_blank" >Google Drive'da yetki ver</a>
        
        <div v-bind:key="idx" v-for="(cloudApiToken, idx) in cloudApiTokens" >
            <p>{{ cloudApiToken.cloudType }}</p>
        </div>

        <div class="large-12 medium-12 small-12 cell">
          <p>List Files</p>
          <ul>
            <li v-bind:key="idx" v-for="(customerFile, idx) in customerFiles">
              <router-link :to="{path:'/api/showCloudFile', query:{fileId: customerFile['_id']['$oid'] }}" target="_blank" >
                {{ customerFile.file_name }}
              </router-link>
              <button v-on:click="deleteFile(customerFile['_id']['$oid'])">Delete File</button>
            </li>
          </ul>
        </div>

        <div class="large-12 medium-12 small-12 cell">
            <label>File
                <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
            </label>
            <button v-on:click="submitFile()">Submit</button>
        </div>
    </div>
</template>

<script>
 import Vue from 'vue'
 import axios from 'axios'
 import { mapState } from 'vuex'
 import {mapActions} from 'vuex'
 import swal from 'sweetalert'
 export default {
     components: {
     },
     name:'cloudApiToken',
     data (){
         return {
             cloudApiTokens: [],
             file: '',
             googleDriveAuthLink: '',
             customerFiles: [],
         }
     },
     methods:{
         calculateGoogleDriveAuthLink: function() {
             this.googleDriveAuthLink = this.baseUrl + '/getGoogleDriveAccessToken';
         },
         listTokens: function() {
             axios({
                 method: 'get',
                 url: '/getAllDefaultCloudApiTokens',
                 baseURL: this.baseUrl,
             }).then(response => {
                 this.cloudApiTokens = response.data.content.tokens
             }).catch(error => {
                 console.log("cloudApiToken sayfası çalıştı");
                 console.log(error);
                 this.$notify({ 
                     group: 'foo',
                     type: 'error', 
                     title: this.$ml.get('ERROR'),
                     text: error
                 })
             });
         },
         handleFileUpload(){
             this.file = this.$refs.file.files[0];
         },
       deleteFile(fileId) {
         axios({
           method: 'POST',
           url: '/deleteCustomerFile',
           baseURL: this.baseUrl,
           data: {
             fileId: fileId
           },
         }).then(response => {
           this.customerFiles = response.data.content.files
         }).catch(error => {
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: error
           })
         });
       },
         submitFile() {
             // Initialize the form data - Form verilerini başlat
             let formData = new FormData();
             //   Add the form data we need to submit - göndermemiz gereken form verilerini ekleyin
             formData.append('myFile', this.file);
             // Make the request to the POST /single-file URL - tek dosya urlsine istekte bulunun
             axios.post(
                 this.baseUrl + '/uploadFile',
                 formData,
                 {
                     headers: {
                         'Content-Type': 'multipart/form-data'
                     }
                 }
             ).then(function(){
                 console.log('SUCCESS!!');
             }).catch(function(){
                 console.log('FAILURE!!');
             });
         },
         getCustomerFiles() {
             axios({
                 method: 'get',
                 url: '/listCustomerFiles',
                 baseURL: this.baseUrl,
             }).then(response => {
                 this.customerFiles = response.data.content.files
             }).catch(error => {
                 this.$notify({
                     group: 'foo',
                     type: 'error',
                     title: this.$ml.get('ERROR'),
                     text: error
                 })
             });
         }
     },
     computed:{
         ...mapState([
             'baseUrl'
         ]),
     },
     mounted(){
         this.listTokens();
         this.calculateGoogleDriveAuthLink();
         this.getCustomerFiles();
     }
 }
</script>

<style scoped>
 
</style>
